"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Shortcut_exports = {};
__export(Shortcut_exports, {
  default: () => Shortcut_default
});
module.exports = __toCommonJS(Shortcut_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M10.2242 11.4242L8.64845 13H15.4C15.6209 13 15.8 12.8209 15.8 12.6V9.59995C15.8 9.37904 15.6209 9.19995 15.4 9.19995H13C12.6686 9.19995 12.4 8.93132 12.4 8.59995C12.4 8.26858 12.6686 7.99995 13 7.99995H15.4C16.2836 7.99995 17 8.7163 17 9.59995V12.6C17 13.4836 16.2836 14.2 15.4 14.2H8.75741L10.2242 15.6668C10.4586 15.9011 10.4586 16.281 10.2242 16.5153C9.98992 16.7496 9.61002 16.7496 9.37571 16.5153L7.18369 14.3233C6.75412 13.8937 6.75412 13.1972 7.18369 12.7677L9.37571 10.5756C9.61003 10.3413 9.98993 10.3413 10.2242 10.5756C10.4586 10.8099 10.4586 11.1898 10.2242 11.4242Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3 5C3 3.89543 3.89543 3 5 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5ZM5 4.2H19C19.4418 4.2 19.8 4.55817 19.8 5V19C19.8 19.4418 19.4418 19.8 19 19.8H5C4.55817 19.8 4.2 19.4418 4.2 19V5C4.2 4.55817 4.55817 4.2 5 4.2Z",
      fill: "currentColor"
    }
  )
);
const SvgShortcut = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var Shortcut_default = SvgShortcut;
